export default [
    {
        path: '/finance/payable',
        name: 'payable',
        props: true,
        component: () => import('@/views/finance/payable/index.vue'),
        meta: {
            pageTitle: 'Payable',
            breadcrumb: [
                {
                text: 'Payable',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/payable/add',
        name: 'create-payable',
        component: () => import('@/views/finance/payable/create.vue'),
        meta: {
            pageTitle: 'Create Payable',
            breadcrumb: [
                {
                text: 'Payable',
                to: { name: 'payable' },
                },
                {
                text: 'Create Payable',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/payable/:id',
        name: 'detail-payable',
        props: true,
        component: () => import('@/views/finance/payable/detail.vue'),
        meta: {
            pageTitle: 'Detail Payable',
            breadcrumb: [
                {
                text: 'Payable',
                to: { name: 'payable' },
                },
                {
                text: 'Detail Payable',
                active: true,
                },
            ],
        },
    },
]